import { useEffect, useState } from 'react';

/**
 * This hook returns a debounced version of the input value.
 * It delays the update of the value until after the specified delay time has passed.
 * Default delay is set to 300 milliseconds.
 * @param value
 * @param delay
 * @returns
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}
